import { render, staticRenderFns } from "./CommonNoticePost.vue?vue&type=template&id=33f92a76&scoped=true&"
import script from "./CommonNoticePost.vue?vue&type=script&lang=js&"
export * from "./CommonNoticePost.vue?vue&type=script&lang=js&"
import style0 from "./CommonNoticePost.vue?vue&type=style&index=0&id=33f92a76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f92a76",
  null
  
)

export default component.exports